<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      title="提示"
      :visible="dialogVisible"
      width="500px"
      @close="handleClose"
      append-to-body
      center>
      <el-form :model="form" label-width="120px">
        <el-form-item label-width="0px">
          没有匹配到车辆，您可修改条件重新查询，或输入时间补录
        </el-form-item>
        <el-form-item label="请选择入场时间">
          <el-date-picker
                  v-model="form.date"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClick">补 录</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import showdialog from '@/minxs/showdialog'
export default {

  data() {
    return {
      form: {
        date: '',
      },
    };
  },
   mixins:[showdialog],
  methods: {
    handleChange() {
    },
    handleClick() {
      this.$confirm('是否补录？', '提示', {
        confirmButtonText: '补录',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        // console.log(this.form);
        this.dialogVisible = false;
      }).catch(() => {
        this.dialogVisible = false;
      });
    },
  }
};
</script>
